<template>
  <div class="base-flow">
    <!-- <div class="ly-card">
      <el-button type="primary" @click.native="dialogVisible = true">添加流程</el-button>
    </div>-->
    <div class="ly-card">
      <ly-table
        :getTableData="getTableData"
        :tableHeader="tableHeader"
        :searchFormData="searchFormData"
        :tableConfig="tableConfig"
        :paginConfig="paginConfig"
        ref="lyTable"
      >
        <template v-slot:action="row">
          <el-button @click="detail(row)" type="primary" size="mini">详情</el-button>
        </template>
      </ly-table>
    </div>
    <el-dialog :title="curItem.name" :visible.sync="dialogVisible" width="1050px" height="600px">
      <bpmn
        url="/public/diagram.bpmn"
        @error="handleError"
        @shown="handleShown"
        @loading="handleLoading"
        :flowString="curItem.detail"
      ></bpmn>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
/* eslint-disable max-len */

import { Dialog } from 'element-ui';
import LyTable from '@/components/LyTable';
import { baseFlowTable } from '@/utils/tableHeader';
import Bpmn from '@/components/Bpmn';

export default {
  name: 'BaseFlow',
  components: { LyTable, Bpmn, ElDialog: Dialog },
  data() {
    return {
      searchFormData: {},
      paginConfig: {},
      tableConfig: {
        data: [
          {
            id: 1,
            name: '修改班级申请',
            detail: `<?xml version="1.0" encoding="UTF-8"?>
<bpmn:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" id="Definitions_1efy4dz" targetNamespace="http://bpmn.io/schema/bpmn" exporter="bpmn-js (https://demo.bpmn.io)" exporterVersion="5.0.4">
  <bpmn:process id="Process_1fxnejv" isExecutable="false">
    <bpmn:task id="Task_1a31lq7" name="申请人">
      <bpmn:outgoing>SequenceFlow_0lbzvx8</bpmn:outgoing>
    </bpmn:task>
    <bpmn:task id="Task_04yz9rp" name="分中心负责人">
      <bpmn:incoming>SequenceFlow_0lbzvx8</bpmn:incoming>
      <bpmn:outgoing>SequenceFlow_1xoc3ns</bpmn:outgoing>
    </bpmn:task>
    <bpmn:sequenceFlow id="SequenceFlow_0lbzvx8" sourceRef="Task_1a31lq7" targetRef="Task_04yz9rp" />
    <bpmn:task id="Task_1fc35pk" name="部长">
      <bpmn:incoming>SequenceFlow_1xoc3ns</bpmn:incoming>
    </bpmn:task>
    <bpmn:sequenceFlow id="SequenceFlow_1xoc3ns" sourceRef="Task_04yz9rp" targetRef="Task_1fc35pk" />
  </bpmn:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1">
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1fxnejv">
      <bpmndi:BPMNShape id="Task_1a31lq7_di" bpmnElement="Task_1a31lq7">
        <dc:Bounds x="160" y="140" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="Task_04yz9rp_di" bpmnElement="Task_04yz9rp">
        <dc:Bounds x="390" y="140" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="SequenceFlow_0lbzvx8_di" bpmnElement="SequenceFlow_0lbzvx8">
        <di:waypoint x="260" y="180" />
        <di:waypoint x="390" y="180" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNShape id="Task_1fc35pk_di" bpmnElement="Task_1fc35pk">
        <dc:Bounds x="620" y="140" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="SequenceFlow_1xoc3ns_di" bpmnElement="SequenceFlow_1xoc3ns">
        <di:waypoint x="490" y="180" />
        <di:waypoint x="620" y="180" />
      </bpmndi:BPMNEdge>
    </bpmndi:BPMNPlane>
  </bpmndi:BPMNDiagram>
</bpmn:definitions>`
          },
          {
            id: 2,
            name: '开班申请',
            detail: `<?xml version="1.0" encoding="UTF-8"?>
<bpmn:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" id="Definitions_1efy4dz" targetNamespace="http://bpmn.io/schema/bpmn" exporter="bpmn-js (https://demo.bpmn.io)" exporterVersion="5.0.4">
  <bpmn:process id="Process_1fxnejv" isExecutable="false">
    <bpmn:task id="Task_1a31lq7" name="申请人">
      <bpmn:outgoing>SequenceFlow_06sxlbn</bpmn:outgoing>
    </bpmn:task>
    <bpmn:task id="Task_0781iip" name="分中心教务">
      <bpmn:incoming>SequenceFlow_06sxlbn</bpmn:incoming>
      <bpmn:outgoing>SequenceFlow_1wgb9ti</bpmn:outgoing>
    </bpmn:task>
    <bpmn:sequenceFlow id="SequenceFlow_06sxlbn" sourceRef="Task_1a31lq7" targetRef="Task_0781iip" />
    <bpmn:task id="Task_0ujjbz5" name="分中心负责人">
      <bpmn:incoming>SequenceFlow_1wgb9ti</bpmn:incoming>
      <bpmn:outgoing>SequenceFlow_1k4744g</bpmn:outgoing>
    </bpmn:task>
    <bpmn:sequenceFlow id="SequenceFlow_1wgb9ti" sourceRef="Task_0781iip" targetRef="Task_0ujjbz5" />
    <bpmn:task id="Task_0irxmaz" name="部门教务">
      <bpmn:incoming>SequenceFlow_1k4744g</bpmn:incoming>
      <bpmn:outgoing>SequenceFlow_1qytmvq</bpmn:outgoing>
    </bpmn:task>
    <bpmn:sequenceFlow id="SequenceFlow_1k4744g" sourceRef="Task_0ujjbz5" targetRef="Task_0irxmaz" />
    <bpmn:task id="Task_1nomt3c" name="教育资源管理部&#10;教务">
      <bpmn:incoming>SequenceFlow_1qytmvq</bpmn:incoming>
    </bpmn:task>
    <bpmn:sequenceFlow id="SequenceFlow_1qytmvq" sourceRef="Task_0irxmaz" targetRef="Task_1nomt3c" />
  </bpmn:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1">
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1fxnejv">
      <bpmndi:BPMNShape id="Task_1a31lq7_di" bpmnElement="Task_1a31lq7">
        <dc:Bounds x="110" y="140" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="Task_0781iip_di" bpmnElement="Task_0781iip">
        <dc:Bounds x="280" y="140" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="SequenceFlow_06sxlbn_di" bpmnElement="SequenceFlow_06sxlbn">
        <di:waypoint x="210" y="180" />
        <di:waypoint x="280" y="180" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNShape id="Task_0ujjbz5_di" bpmnElement="Task_0ujjbz5">
        <dc:Bounds x="450" y="140" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="SequenceFlow_1wgb9ti_di" bpmnElement="SequenceFlow_1wgb9ti">
        <di:waypoint x="380" y="180" />
        <di:waypoint x="450" y="180" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNShape id="Task_0irxmaz_di" bpmnElement="Task_0irxmaz">
        <dc:Bounds x="620" y="140" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="SequenceFlow_1k4744g_di" bpmnElement="SequenceFlow_1k4744g">
        <di:waypoint x="550" y="180" />
        <di:waypoint x="620" y="180" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNShape id="Task_1nomt3c_di" bpmnElement="Task_1nomt3c">
        <dc:Bounds x="790" y="140" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="SequenceFlow_1qytmvq_di" bpmnElement="SequenceFlow_1qytmvq">
        <di:waypoint x="720" y="180" />
        <di:waypoint x="790" y="180" />
      </bpmndi:BPMNEdge>
    </bpmndi:BPMNPlane>
  </bpmndi:BPMNDiagram>
</bpmn:definitions>`
          },
          {
            id: 3,
            name: '教师代课申请',
            detail: `<?xml version="1.0" encoding="UTF-8"?>
<bpmn:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" id="Definitions_1efy4dz" targetNamespace="http://bpmn.io/schema/bpmn" exporter="bpmn-js (https://demo.bpmn.io)" exporterVersion="5.0.4">
  <bpmn:process id="Process_1fxnejv" isExecutable="false">
    <bpmn:task id="Task_1a31lq7" name="申请人">
      <bpmn:outgoing>SequenceFlow_0lbzvx8</bpmn:outgoing>
    </bpmn:task>
    <bpmn:task id="Task_04yz9rp" name="分中心负责人">
      <bpmn:incoming>SequenceFlow_0lbzvx8</bpmn:incoming>
      <bpmn:outgoing>SequenceFlow_1xoc3ns</bpmn:outgoing>
    </bpmn:task>
    <bpmn:sequenceFlow id="SequenceFlow_0lbzvx8" sourceRef="Task_1a31lq7" targetRef="Task_04yz9rp" />
    <bpmn:task id="Task_1fc35pk" name="部长">
      <bpmn:incoming>SequenceFlow_1xoc3ns</bpmn:incoming>
    </bpmn:task>
    <bpmn:sequenceFlow id="SequenceFlow_1xoc3ns" sourceRef="Task_04yz9rp" targetRef="Task_1fc35pk" />
  </bpmn:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1">
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1fxnejv">
      <bpmndi:BPMNShape id="Task_1a31lq7_di" bpmnElement="Task_1a31lq7">
        <dc:Bounds x="160" y="140" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="Task_04yz9rp_di" bpmnElement="Task_04yz9rp">
        <dc:Bounds x="390" y="140" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="SequenceFlow_0lbzvx8_di" bpmnElement="SequenceFlow_0lbzvx8">
        <di:waypoint x="260" y="180" />
        <di:waypoint x="390" y="180" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNShape id="Task_1fc35pk_di" bpmnElement="Task_1fc35pk">
        <dc:Bounds x="620" y="140" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="SequenceFlow_1xoc3ns_di" bpmnElement="SequenceFlow_1xoc3ns">
        <di:waypoint x="490" y="180" />
        <di:waypoint x="620" y="180" />
      </bpmndi:BPMNEdge>
    </bpmndi:BPMNPlane>
  </bpmndi:BPMNDiagram>
</bpmn:definitions>`
          },
          {
            id: 4,
            name: '教师替换申请（开课前）',
            detail: `<?xml version="1.0" encoding="UTF-8"?>
<bpmn:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" id="Definitions_1efy4dz" targetNamespace="http://bpmn.io/schema/bpmn" exporter="bpmn-js (https://demo.bpmn.io)" exporterVersion="5.0.4">
  <bpmn:process id="Process_1fxnejv" isExecutable="false">
    <bpmn:task id="Task_1a31lq7" name="申请人">
      <bpmn:outgoing>SequenceFlow_0lbzvx8</bpmn:outgoing>
    </bpmn:task>
    <bpmn:task id="Task_04yz9rp" name="分中心教务">
      <bpmn:incoming>SequenceFlow_0lbzvx8</bpmn:incoming>
      <bpmn:outgoing>SequenceFlow_1xoc3ns</bpmn:outgoing>
    </bpmn:task>
    <bpmn:sequenceFlow id="SequenceFlow_0lbzvx8" sourceRef="Task_1a31lq7" targetRef="Task_04yz9rp" />
    <bpmn:task id="Task_1fc35pk" name="部门教务">
      <bpmn:incoming>SequenceFlow_1xoc3ns</bpmn:incoming>
    </bpmn:task>
    <bpmn:sequenceFlow id="SequenceFlow_1xoc3ns" sourceRef="Task_04yz9rp" targetRef="Task_1fc35pk" />
  </bpmn:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1">
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1fxnejv">
      <bpmndi:BPMNShape id="Task_1a31lq7_di" bpmnElement="Task_1a31lq7">
        <dc:Bounds x="160" y="140" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="Task_04yz9rp_di" bpmnElement="Task_04yz9rp">
        <dc:Bounds x="390" y="140" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="SequenceFlow_0lbzvx8_di" bpmnElement="SequenceFlow_0lbzvx8">
        <di:waypoint x="260" y="180" />
        <di:waypoint x="390" y="180" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNShape id="Task_1fc35pk_di" bpmnElement="Task_1fc35pk">
        <dc:Bounds x="620" y="140" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="SequenceFlow_1xoc3ns_di" bpmnElement="SequenceFlow_1xoc3ns">
        <di:waypoint x="490" y="180" />
        <di:waypoint x="620" y="180" />
      </bpmndi:BPMNEdge>
    </bpmndi:BPMNPlane>
  </bpmndi:BPMNDiagram>
</bpmn:definitions>`
          },
          {
            id: 5,
            name: '教师替换申请（开课后）',
            detail: `<?xml version="1.0" encoding="UTF-8"?>
<bpmn:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" id="Definitions_1efy4dz" targetNamespace="http://bpmn.io/schema/bpmn" exporter="bpmn-js (https://demo.bpmn.io)" exporterVersion="5.0.4">
  <bpmn:process id="Process_1fxnejv" isExecutable="false">
    <bpmn:task id="Task_1a31lq7" name="申请人">
      <bpmn:outgoing>SequenceFlow_0yp9x1a</bpmn:outgoing>
    </bpmn:task>
    <bpmn:task id="Task_0vyxx4j" name="分中心教务">
      <bpmn:incoming>SequenceFlow_0yp9x1a</bpmn:incoming>
      <bpmn:outgoing>SequenceFlow_062f7g7</bpmn:outgoing>
    </bpmn:task>
    <bpmn:sequenceFlow id="SequenceFlow_0yp9x1a" sourceRef="Task_1a31lq7" targetRef="Task_0vyxx4j" />
    <bpmn:task id="Task_1e8f0v1" name="分中心负责人">
      <bpmn:incoming>SequenceFlow_062f7g7</bpmn:incoming>
      <bpmn:outgoing>SequenceFlow_0hkb5wx</bpmn:outgoing>
    </bpmn:task>
    <bpmn:sequenceFlow id="SequenceFlow_062f7g7" sourceRef="Task_0vyxx4j" targetRef="Task_1e8f0v1" />
    <bpmn:task id="Task_0kramuu" name="部门教务">
      <bpmn:incoming>SequenceFlow_0hkb5wx</bpmn:incoming>
    </bpmn:task>
    <bpmn:sequenceFlow id="SequenceFlow_0hkb5wx" sourceRef="Task_1e8f0v1" targetRef="Task_0kramuu" />
  </bpmn:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1">
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1fxnejv">
      <bpmndi:BPMNShape id="Task_1a31lq7_di" bpmnElement="Task_1a31lq7">
        <dc:Bounds x="120" y="140" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="Task_0vyxx4j_di" bpmnElement="Task_0vyxx4j">
        <dc:Bounds x="320" y="140" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="SequenceFlow_0yp9x1a_di" bpmnElement="SequenceFlow_0yp9x1a">
        <di:waypoint x="220" y="180" />
        <di:waypoint x="320" y="180" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNShape id="Task_1e8f0v1_di" bpmnElement="Task_1e8f0v1">
        <dc:Bounds x="520" y="140" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="SequenceFlow_062f7g7_di" bpmnElement="SequenceFlow_062f7g7">
        <di:waypoint x="420" y="180" />
        <di:waypoint x="520" y="180" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNShape id="Task_0kramuu_di" bpmnElement="Task_0kramuu">
        <dc:Bounds x="720" y="140" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="SequenceFlow_0hkb5wx_di" bpmnElement="SequenceFlow_0hkb5wx">
        <di:waypoint x="620" y="180" />
        <di:waypoint x="720" y="180" />
      </bpmndi:BPMNEdge>
    </bpmndi:BPMNPlane>
  </bpmndi:BPMNDiagram>
</bpmn:definitions>`
          }
        ]
      },
      tableHeader: baseFlowTable,
      getTableData: () => {},
      dialogVisible: false,
      curItem: {}
    };
  },
  mounted() {
    this.search();
    this.paginConfig = {
      page_no: 1,
      page_size: 10,
      total: this.tableConfig.data.length
    };
  },
  methods: {
    search() {
      this.$refs.lyTable.setData();
    },
    detail(row) {
      this.dialogVisible = true;
      this.curItem = { ...row };
    },
    initFlowCop() {},
    handleError(err) {
      console.error('failed to show diagram', err);
    },
    handleShown() {
      console.log('diagram shown');
    },
    handleLoading() {
      console.log('diagram loading');
    }
  }
};
</script>
